import { createRouter, createWebHistory } from 'vue-router';
import HomePageView from '../views/HomePageView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // HOME PAGE ROUTES
    {
      path: '/',
      name: 'home',
      component: HomePageView,
      meta: {
        title: 'clarity | Independent Financial Advice & Wealth Management UK'
      }
    },
    {
      path: '/homepage',
      name: 'homepage',
      component: HomePageView,
      meta: {
        title: 'clarity | Independent Financial Advice & Wealth Management UK'
      }
    },
    // MAIN SITE PAGES
    {
      path: '/whatwedo',
      name: 'whatwedo',
      component: () => import('../views/WhatWeDoView.vue'),
      meta: {
        title: 'What We Do | Financial Planning, Investments & Wealth Succession'
      }
    },
    {
      path: '/whowehelp',
      name: 'whowehelp',
      component: () => import('../views/WhoWeHelpView.vue'),
      meta: {
        title: 'Who We Help | Individuals, Families & Trustees'
      }
    },
    {
      path: '/meettheteam',
      name: 'meettheteam',
      component: () => import('../views/MeetTheTeamView.vue'),
      meta: {
        title: 'Meet the clarity Team | Financial Advisers & Investment Experts'
      }
    },
    {
      path: '/clarityonline',
      name: 'clarityonline',
      component: () => import('../views/ClarityOnlineView.vue'),
      meta: {
        title: 'clarityONLINE | Secure Client Portal & Mobile App'
      }
    },
    {
      path: '/insights',
      name: 'insights',
      component: () => import('../views/InsightsView.vue'),
      meta: {
        title: 'Technical Insights, Market Updates & clarityON Podcast'
      }
    },
    {
      path: '/insightsarticle',
      name: 'insightsarticle',
      component: () => import('../views/InsightsArticleView.vue'),
      meta: {
        title: 'clarity | Insights Article'
      }
    },
    {
      path: '/employers',
      name: 'employers',
      component: () => import('../views/EmployersView.vue'),
      meta: {
        title: 'Employee Financial Wellbeing & Benefits Technology'
      }
    },
    {
      path: '/retirement-calculator',
      name: 'retirementcalculator',
      component: () => import('../views/RetirementCalculatorView.vue'),
      meta: {
        title: 'Retirement Calculator | Calculate Your Retirement Income | clarity'
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacypolicy',
      component: () => import('../views/landing_pages/PrivacyPolicyPage.vue'),
      meta: {
        title: 'clarity | Privacy and Cookies Policy'
      }
    },
    //  LANDING PAGES
    {
      path: '/searchresults',
      name: 'searchresults',
      component: () => import('../views/landing_pages/SearchResultsView.vue'),
      meta: {
        title: 'Search Results | clarity'
      }
    },
    {
      path: '/pwc',
      name: 'pwc',
      component: () => import('../views/landing_pages/PwcView.vue'),
      meta: {
        title: 'clarity & PwC | Financial Planning & Investment Advice for Employees'
      }
    },
    {
      path: '/mishcon',
      name: 'mishcon',
      component: () => import('../views/landing_pages/MdrView.vue'),
      meta: {
        title: 'MDRclarity | Integrated Financial Advice for Employees'
      }
    },
    {
      path: '/setfords',
      name: 'setfords',
      component: () => import('../views/landing_pages/SetfordsView.vue'),
      meta: {
        title: 'Setfords | Integrated Financial Advice for Employees'
      }
    },
    {
      path: '/setfords/clients',
      name: 'clients',
      component: () => import('../components/SetfordsClients.vue'),
      meta: {
        title: 'Setfords Clients | Integrated Financial Advice for Employees'
      }
    },
    {
      path: '/setfords/consultants',
      name: 'consultants',
      component: () => import('../components/SetfordsStaff.vue'),
      meta: {
        title: 'Setfords Clients | Integrated Financial Advice for Employees'
      }
    },
    {
      path: '/clientreferral',
      name: 'clientreferral',
      component: () => import('../views/landing_pages/ClientReferralPage.vue'),
      meta: {
        title: 'clarity | Client Referral'
      }
    },
    {
      path: '/book-with-louise-challis',
      name: 'book-with-louise-challis',
      component: () => import('../views/landing_pages/BookMeetingView.vue'),
      meta: {
        title: 'Book a Free Call with Louise Challis | clarity Financial Advisers'
      }
    },
    {
      path: '/book-with-louise-challis-partnerships',
      name: 'book-with-louise-challis-partnerships',
      component: () => import('../views/landing_pages/BookMeetingPartnersView.vue'),
      meta: {
        title: 'clarity | Independent Financial Advice & Wealth Management UK'
      }
    },
    {
      path: '/book-with-naomi-kewell',
      name: 'book-with-naomi-kewell',
      component: () => import('../views/landing_pages/BookMeetingMdrView.vue'),
      meta: {
        title: 'Book Your Free Initial Consultation with Naomi Kewell | clarity Financial Advisers'
      }
    },
    {
      path: '/book-with-andrew-kemp-partners-directors',
      name: 'book-with-andrew-kemp-partners-directors',
      component: () => import('../views/landing_pages/BookAdviserMeetingPartnersView.vue'),
      meta: {
        title: 'Book Your Free Consultation with Andrew Kemp | clarity Financial Advisers'
      }
    },
    {
      path: '/book-with-andrew-kemp',
      name: 'book-with-andrew-kemp',
      component: () => import('../views/landing_pages/BookAdviserMeetingView.vue'),
      meta: {
        title: 'Book Your Free Consultation with Andrew Kemp | clarity Financial Advisers'
      }
    },
    {
      path: '/independent-schools-investment-management',
      name: 'independent-schools-investment-management',
      component: () => import('../views/landing_pages/IndependentSchoolsView.vue'),
      meta: {
        title: 'Independent Schools Investment Management | clarity Ltd'
      }
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('../views/landing_pages/ErrorPage.vue'),
      meta: {
        title: 'Page Not Found | clarity'
      }
    }
  ]
});

router.beforeEach((to, from) => {
  window.document.title = to.meta.title
  const pageName = to.name;
  const pagePath = to.path;
  if(pageName === undefined) {
    if(pagePath !== '/.well-known/apple-app-site-association') {
      return { name: 'error'}
    }
  }
});

export default router
